const recentlyViewed = async () => {
    const section = document.querySelector('section-recentlyviewed');
    if (!section) return;
    const queryString = getSearchQueryString(section);
    if (!queryString) return;
    try {
        const response = await fetch(`${window.routes.search_url}?view=recently-viewed-products&type=product&q=${queryString}`, {
            credentials: "same-origin",
            method: "GET",
        });
        const content = await response.text();
        const tempElement = document.createElement("div");
        tempElement.innerHTML = content;
        if(tempElement.querySelector('.products_count').innerHTML == 0) return
        const placeholder = section.querySelector(".recently-viewed-products-placeholder");
        const newContent = tempElement.querySelector('.recently-viewed-products-placeholder').innerHTML;
        placeholder.innerHTML = newContent;
        section.style.display = 'block';
        const flickityElement = section.querySelector(".slider-flickity");
        if (flickityElement) {
            const flkty = new Flickity(flickityElement, {
                cellAlign: 'left',
                freeScroll: true,
                pageDots: false,
                groupCells: true,
                contain: true
            });
            flkty.resize();
        }
        section.querySelectorAll("card-colours").forEach(generateSwatches);
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    } catch (error) {
        console.error("Error fetching recently viewed products:", error);
    }
};

const getSearchQueryString = (section) => {
    const currentProductId = section.querySelector('[data-currentProductId]')?.getAttribute('data-currentProductId');
    if (!currentProductId) return '';
    let items = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]");
    items = items.filter(item => item !== currentProductId);
    return items.map(item => `id:${item}`).join(" OR ");
};

document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector('section-recentlyviewed');
    if (section) {
        recentlyViewed();
    }
});